export const apiKeysZh = {
  breadcrumb: {
    root: '开发对接',
    active: '密钥与回执',
  },
  header: {
    title: '密钥与回执配置',
    subtitle: '管理 API 密钥及短信回执推送地址，确保对接安全与回执及时送达',
    keyGroups: '{n} 组密钥',
  },
  securityTip: '请妥善保管 Secret 密钥，切勿在客户端代码或公开仓库中暴露。如密钥已泄露，请立即联系平台重置。',
  tabs: {
    verify: '验证码通知',
    market: '营销短信',
  },
  keyCard: {
    verifyLabel: '验证码通知密钥',
    verifyDesc: '用于发送验证码、通知类短信',
    marketLabel: '营销短信密钥',
    marketDesc: '用于发送营销类短信',
    statusActive: '已启用',
    createdAt: '创建于 {date}',
    lastUsed: '最近使用 {date}',
    remark: '备注',
    verifyRemark: '验证码通知专用',
    marketRemark: '营销短信专用',
  },
  fields: {
    key: 'KEY',
    secret: 'Secret',
  },
  actions: {
    copy: '复制',
    show: '显示',
    hide: '隐藏',
  },
  callback: {
    title: '回执推送配置',
    desc: '配置回执推送地址，平台将在短信状态变更时向该地址推送回执报告',
    placeholder: 'https://your-server.com/callback',
    saving: '保存中',
    saved: '已保存',
    save: '保存配置',
    paramsTitle: '回执参数说明',
    paramName: '参数名',
    paramType: '类型',
    paramDesc: '说明',
    required: '必填',
    returnHint: '收到回执后请返回 ok，否则平台将重试推送（最多3次，间隔5分钟）',
  },
  callbackParams: {
    date: '回调时间',
    smsId: '短信ID',
    phone: '手机号码',
    index: '批次序号',
    status: '状态码（0=成功，其他=失败）',
  },
  errors: {
    noUserInfo: '未获取到用户信息',
    noPortConfig: '未找到对应端口配置',
  },
}

export const apiKeysEn = {
  breadcrumb: {
    root: 'API Integration',
    active: 'Keys & Callbacks',
  },
  header: {
    title: 'API Keys & Callbacks',
    subtitle: 'Manage API keys and delivery receipt URLs for secure integration and timely callbacks',
    keyGroups: '{n} key sets',
  },
  securityTip: 'Keep your Secret key secure. Never expose it in client-side code or public repositories. Contact support immediately if your key is compromised.',
  tabs: {
    verify: 'OTP & Notifications',
    market: 'Marketing',
  },
  keyCard: {
    verifyLabel: 'OTP & Notification Key',
    verifyDesc: 'For OTP and notification messages',
    marketLabel: 'Marketing Key',
    marketDesc: 'For marketing messages',
    statusActive: 'Active',
    createdAt: 'Created {date}',
    lastUsed: 'Last used {date}',
    remark: 'Remark',
    verifyRemark: 'OTP & notifications',
    marketRemark: 'Marketing SMS',
  },
  fields: {
    key: 'KEY',
    secret: 'Secret',
  },
  actions: {
    copy: 'Copy',
    show: 'Show',
    hide: 'Hide',
  },
  callback: {
    title: 'Delivery Receipt Callback',
    desc: 'Configure a callback URL. The platform pushes delivery reports when message status changes.',
    placeholder: 'https://your-server.com/callback',
    saving: 'Saving',
    saved: 'Saved',
    save: 'Save Configuration',
    paramsTitle: 'Callback Parameters',
    paramName: 'Parameter',
    paramType: 'Type',
    paramDesc: 'Description',
    required: 'Required',
    returnHint: 'Return ok after receiving a callback. Otherwise the platform retries up to 3 times at 5-minute intervals.',
  },
  callbackParams: {
    date: 'Callback time',
    smsId: 'SMS ID',
    phone: 'Phone number',
    index: 'Batch index',
    status: 'Status code (0=success, other=failed)',
  },
  errors: {
    noUserInfo: 'Unable to retrieve user information',
    noPortConfig: 'Port configuration not found',
  },
}

export const apiKeysJa = {
  breadcrumb: {
    root: 'API連携',
    active: 'キーとコールバック',
  },
  header: {
    title: 'APIキーとコールバック設定',
    subtitle: 'APIキーとSMS配信レシートURLを管理し、安全な連携とタイムリーなコールバックを確保',
    keyGroups: '{n} 組のキー',
  },
  securityTip: 'Secretキーは厳重に管理してください。クライアントコードや公開リポジトリに露出しないでください。漏洩した場合は直ちにプラットフォームに連絡してリセットしてください。',
  tabs: {
    verify: 'OTP・通知',
    market: 'マーケティング',
  },
  keyCard: {
    verifyLabel: 'OTP・通知キー',
    verifyDesc: 'OTP・通知SMSの送信用',
    marketLabel: 'マーケティングキー',
    marketDesc: 'マーケティングSMSの送信用',
    statusActive: '有効',
    createdAt: '作成日 {date}',
    lastUsed: '最終使用 {date}',
    remark: '備考',
    verifyRemark: 'OTP・通知専用',
    marketRemark: 'マーケティングSMS専用',
  },
  fields: {
    key: 'KEY',
    secret: 'Secret',
  },
  actions: {
    copy: 'コピー',
    show: '表示',
    hide: '非表示',
  },
  callback: {
    title: '配信レシートコールバック',
    desc: 'コールバックURLを設定。SMSステータス変更時にプラットフォームから配信レポートをプッシュします。',
    placeholder: 'https://your-server.com/callback',
    saving: '保存中',
    saved: '保存済み',
    save: '設定を保存',
    paramsTitle: 'コールバックパラメータ',
    paramName: 'パラメータ',
    paramType: '型',
    paramDesc: '説明',
    required: '必須',
    returnHint: 'コールバック受信後は ok を返してください。返さない場合、最大3回（5分間隔）で再試行します。',
  },
  callbackParams: {
    date: 'コールバック時間',
    smsId: 'SMS ID',
    phone: '電話番号',
    index: 'バッチ番号',
    status: 'ステータスコード（0=成功、その他=失敗）',
  },
  errors: {
    noUserInfo: 'ユーザー情報を取得できませんでした',
    noPortConfig: '対応するポート設定が見つかりません',
  },
}
